import Image from 'components/Image'
import Link from 'components/Navigation/WrapperLink'
import styles from './SmallEvent.module.scss'

export default function SmallEvent({ event }) {
  const { name, slug, image } = event

  return (
    <article className={styles.teaser}>
      <div className={styles.wrap}>
        <div className={styles.imgWrap}>
          <Link data={{ slug: `/${slug}`, type: 'event' }}>
            {image && (
              <div className={styles.imageWrap}>
                <Image image={image} size="teaser" layout="responsive" />
              </div>
            )}
          </Link>
        </div>

        <div className={styles.contentWrap}>
          <Link data={{ slug: `/${slug}`, type: 'event' }}>
            <h6 className={styles.title}>{name}</h6>
            <span className={styles.link}>Katso profiili</span>
          </Link>
        </div>
      </div>
    </article>
  )
}
